/* eslint-disable react/prop-types */
import React from 'react';
import moment from 'moment';
import RescheduleSection from '../../../../common/components/RescheduleSection';
import BlockedAutoAllocationSection from './BlockedAutoAllocationSection';
import PricingSection from './PricingSection';
import GarageMembershipTag from '../../../components/GarageMembershipTag';
import { getIsGarageMembership } from '../../../../../common/garageMembership';

const getReschedules = (booking) =>
  booking.garageInvites.reduce((acc, invite) => {
    const collectionTimeChanges = invite.proposedChanges.find((pc) => pc.type === 'collection-time');

    if (collectionTimeChanges) {
      acc.push({
        collectionTimeChanges,
        creationDateTime: invite.creationDateTime,
      });
    }

    return acc;
  }, []);

const GaragesAllocationCard = ({ booking }) => {
  const { collectionDateTimeLocal, collectionAddress, customer } = booking || {};
  const reschedules = getReschedules(booking);

  return (
    <a className="allocation-card" target="_blank" href={`/bookings/${booking.bookingId}`} rel="noreferrer">
      <div className="allocation-card-title">
        {customer?.firstName} {customer?.lastName}
      </div>

      <RescheduleSection booking={booking} reschedules={reschedules} />

      {getIsGarageMembership(booking) && <GarageMembershipTag />}

      <BlockedAutoAllocationSection booking={booking} />

      <PricingSection booking={booking} />

      <div className="allocation-card-footer">
        {!(reschedules && reschedules.length) && (
          <span> {moment(collectionDateTimeLocal).format('DD MMM YYYY')} - </span>
        )}{' '}
        {collectionAddress.postcode}
      </div>
    </a>
  );
};

export default GaragesAllocationCard;
